import Block from './Block'
import Splide from '@splidejs/splide'
import gsap from 'gsap'
import store from '../util/store'

export default class SliderCards extends Block {
  getElems() {
    this.sliderContainer = this.el.querySelector('.splide')
    this.slider = null
    this.initialSlides = Array.from(this.el.querySelectorAll('.splide__slide'))
    this.slides = []
    this.lenis = store.smoothScroll
    this.lenisStopped = false
    this.cursor = store.cursor
  }

  init() {
    this.slider = new Splide(this.sliderContainer, {
      pagination: false,
      arrows: false,
      wheel: true,
      releaseWheel: true,
      perPage: 3,
      lazyLoad: false,
      type: 'loop',
      focus: 'center',
      gap: 17100 / 1512 + 'vw',
      autoWidth: true,
      wheelSleep: 800,
      autoplay: true
    }).mount()

    this.slides = Array.from(this.el.querySelectorAll('.splide__slide'))

    this.slides.forEach((slide) => {
      if (slide === this.initialSlides[0]) {
        slide.classList.add('--active')
      } else {
        gsap.set(slide.querySelector('p'), {
          opacity: 0
        })

        gsap.set(slide.querySelector('.splide__slide__content'), {
          y: slide.querySelector('p').offsetHeight * 100 / 1512 + 3200 / 1512 + 'vw'
        })
      }
    })
  }

  events() {
    this.slider.on('move', (newIndex, prevIndex) => this._handleMove(newIndex, prevIndex))

    this.sliderContainer.addEventListener('mousemove', () => {
      if (!this.lenisStopped) {
        this.lenis.stop()
      }
    })

    this.sliderContainer.addEventListener('mouseleave', () => {
      this.lenisStopped = false
      this.lenis.start()
    })

    this.slides.forEach((slide) => {
      slide.addEventListener('mouseenter', () => {
        if (!slide.classList.contains('--active')) return

        this.cursor.addState('-xl -white-full')
        this.cursor.setIcon('resources--assets--images--svg--arrow-external-big')
      })

      slide.addEventListener('mouseleave', () => {
        if (!slide.classList.contains('--active')) return

        this.cursor.removeState('-xl -white-full')
        this.cursor.removeIcon()
      })
    })
  }

  _handleMove(newIndex, prevIndex) {
    this.initialSlides[prevIndex].classList.remove('--active')
    this.initialSlides[newIndex].classList.add('--active')

    const tl = gsap.timeline({
      paused: true,
      defaults: {
        ease: 'power3.out',
        duration: 0.5
      }
    })

    tl.to(this.initialSlides[prevIndex].querySelector('.splide__slide__content'), {
      y: this.initialSlides[prevIndex].querySelector('p').offsetHeight * 100 / 1512 + 3200 / 1512 + 'vw'
    })

    tl.to(this.initialSlides[prevIndex].querySelector('p'), {
      opacity: 0
    }, '<')

    tl.to(this.initialSlides[newIndex].querySelector('.splide__slide__content'), {
      y: 0
    }, '<')

    tl.to(this.initialSlides[newIndex].querySelector('p'), {
      opacity: 1
    }, '<')

    tl.play()
  }
}
